import React, { Component } from "react"
import { Field, FormSection, reduxForm } from 'redux-form';
import validate from './validate'
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardBody, Button, CardTitle, CardText, Row, Col, FormGroup } from 'reactstrap';

class ProductPriceForm extends Component {
    render(){
        return(
<Card className="col-12 mb-3">
                    <CardBody>
                    <div className="text-right">
                <Button
                  style={{ marginRight: 16 }}
                  type="button"
                  onClick={this.props.previousPage}>
                  Previous
                </Button>
                        <Button  type="submit" >Next</Button>
                    </div>
                    </CardBody>
        </Card>
        )
    }
}

export default reduxForm({
    form: 'CreateVendorForm', // <------ same form name
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate
  })(ProductPriceForm)